import {createRootRouteWithContext, Outlet, redirect} from "@tanstack/react-router";
import {TanStackRouterDevtools} from "@tanstack/react-router-devtools";
import {useQuery} from "@tanstack/react-query";
import localforage from "localforage";
import {LF_DEBUG_KEY} from "../auth/authenticator.tsx";
import {selfTqo} from "../rpc/webrpc-client.gen.ts";
import React from "react";
import {AppRouterContext} from "../routing/AppRouterContext.tsx";
import {ToasterProvider} from "../bomb/bomb.tsx";

const ReactQueryDevtoolsProduction = React.lazy(() =>
    import("@tanstack/react-query-devtools/build/modern/production.js").then(
        (d) => ({
            default: d.ReactQueryDevtools,
        }),
    ),
);

export const Route = createRootRouteWithContext<AppRouterContext>()({
    component: UberShell,
    beforeLoad: ({context, location}) => {
        // console.log(`router location ${JSON.stringify(location)}`);

        if (context.authenticator.getJwt()) {
            return context.queryClient.ensureQueryData(selfTqo(context.mothership))
                .then(rpcme => {
                    return {...context, myself: rpcme.srv.self};
                })
                .catch((xc: unknown) => {
                    console.log(`self threw ${JSON.stringify(xc)}`);
                });
        } else {
            if (location.pathname === "/login") {
                return context;
            }

            throw redirect({
                to: "/login",
                // search: {
                //     goto: location.href,
                // },
            });
        }
    },
});

export const isDebugModeTqo = {
    queryKey: ["debugMode"],
    queryFn: () => {
        return localforage.getItem<boolean>(LF_DEBUG_KEY);
    }
};

function UberShell() {
    const {data: isDebugMode} = useQuery(isDebugModeTqo);
    return <ToasterProvider>
        <Outlet/>
        {isDebugMode ? <>
            <TanStackRouterDevtools/>
            <React.Suspense fallback={null}>
                <ReactQueryDevtoolsProduction/>
            </React.Suspense>
        </> : null}
    </ToasterProvider>
}
